import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin-top: -55px;
  height: 75px;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    justify-content: space-around;
  }
`;

const Items = styled.div`
  margin-left: 10%;
  font-size: 18px;
  font-weight: 600;
  @media (max-width: 768px) {
    margin-left: 0;
    font-size: 13px;
  }
`;

const Item = styled.span`
  margin-left: 25px;
  cursor: pointer;
  @media (max-width: 768px) {
    :first-child {
      margin-left: 0;
    }
  }
`;

export const DetailHeader = ({ isMovie, setHome, setCast, setSeason }) => {
  const onHomeClick = () => {
    setHome(true);
    setCast(false);
    setSeason(false);
  };

  const onCastClick = () => {
    setHome(false);
    setCast(true);
    setSeason(false);
  };

  const onSeasonClick = () => {
    setHome(false);
    setCast(false);
    setSeason(true);
  };

  return (
    <Container>
      {isMovie ? (
        <Items>
          <Item onClick={onHomeClick}>기본 정보</Item>
          <Item onClick={onCastClick}>출연진</Item>
        </Items>
      ) : (
        <Items>
          <Item onClick={onHomeClick}>기본 정보</Item>
          <Item onClick={onCastClick}>출연진</Item>
          <Item onClick={onSeasonClick}>시즌 정보</Item>
        </Items>
      )}
    </Container>
  );
};
